import { Service } from "../shared/Service";

export class IncentivoService extends Service{

  constructor(){
    super('incentivo');
  }

}